// extracted by mini-css-extract-plugin
export default {"divider":"PunchupDivider_divider__70wVn"};